import { useContext, useEffect, useState } from "react";
import ModalTemplate from "../../../common/ModalTemplate";
import { Context } from "../../Provider";
import DivSpinner from '../../../common/DivSpinner';
import { fetchCompletedDetails } from '../../service';
import { removeFtm } from "../../../storage/ftm";
import { removeStep } from "../../../storage/step";
import { theme } from "../../../theme";
import DownloadCard from "../../../common/DownloadCard";

const CompletedBody = ({ handleHideCompleted }) => {
    const { state } = useContext(Context);
    const { ftm } = state;

    const [completedDetails, setCompletedDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getCompletedDetails = async () => {
            try {
                setLoading(true);
                const response = await fetchCompletedDetails();
                if (response.status === "Success") {
                    setCompletedDetails({
                        qr_android: response?.qr_android,
                        qr_ios: response?.qr_ios,
                        settings: response?.settings
                    });
                    setLoading(false);
                }
            } catch (error) {
                console.error("Error fetching completed details:", error);
            } finally {
                setLoading(false);
            }
        };

        getCompletedDetails();
    }, []);

    const LoadingContent = () => (
        <div style={{ height: `${window.innerHeight - 387}px` }}>
            <DivSpinner />
        </div>
    );

    return (
        <div className="d-flex justify-content-center align-items-center">
            {loading ? <LoadingContent /> : (
                <div className="text-center p-1">
                    {/* Logo */}
                    <div className="mb-3">
                        <img src="./assets/img/instafix-logo-1.png" alt="Logo" style={{ height: "60px" }} />
                    </div>

                    {/* Subtext */}
                    <p className="text-muted small mb-2">Thanks so much for joining Our Site!.</p>

                    {/* Heading */}
                    <h4 className="mb-1 fw-semibold">Hello {ftm?.ftm_forename} {ftm?.ftm_surname},</h4>
                    <h5 className="mb-3 fw-normal text-dark">Registration completed</h5>
                    <h4 className="mb-1 fw-semibold">Your reference number is #{ftm?.ftm_id}</h4>

                    {/* Message */}
                    <p className="text-muted mb-2">Download our app and get started!</p>

                    {/* Android Download Card */}
                    <DownloadCard
                        platform="ANDROID"
                        qrSrc={completedDetails?.qr_android}
                        badgeHeight="40px"
                    />

                    {/* iOS Download Card */}
                    <DownloadCard
                        platform="IOS"
                        qrSrc={completedDetails?.qr_ios}
                        badgeHeight="40px"
                    />

                    {/* Contact Info */}
                    <p className="d-flex justify-content-center align-items-center gap-2 text-muted mb-3">
                        <strong>Contact: {completedDetails?.settings?.company_contact_number}</strong>
                        <span>|</span>
                        <strong>WhatsApp: {completedDetails?.settings?.company_whatsapp_number}</strong>
                    </p>

                    {/* Divider */}
                    <hr className="my-2" style={{ borderTop: "1px dashed #ccc" }} />

                    {/* Instructions */}
                    <p className="text-secondary small mb-4">
                        We have successfully received your documents, certificates, and all other details. These will undergo a review process to ensure approval. We appreciate your patience while we complete this review. We will notify you as soon as the process is finalized.
                    </p>

                    <p className="text-secondary small mb-4">
                        <strong>Note:</strong> that this link is only valid until your account has been verified and approved
                    </p>

                    {/* Button */}
                    <button
                        className={`btn btn-${theme.main} px-4 py-2 fw-bold mt-4 w-100`}
                        onClick={() => {
                            removeFtm();
                            removeStep();
                            handleHideCompleted();
                            window.location.href = "/";
                        }}
                    >
                        complete registration
                    </button>
                </div>
            )}
        </div>
    );
};

const Completed = ({ handleHideCompleted }) => {
    return (
        <ModalTemplate
            show={true}
            handleClose={() => { }}
            size={null}
            centered
            title={null}
            body={<CompletedBody handleHideCompleted={handleHideCompleted} />}
            footer={null}
            backdrop="static"
            keyboard={false}
        />
    );
};

export default Completed;